import { useState, createContext, useEffect } from "react";

export const InnerWidthContext = createContext({
    isMobile: false,
    innerWidth: 0,
});

export const InnerWidthContextProvider = (props: any) => {
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const [innerWidth, setInnerWidth] = useState<number>(0);

    function updateIsMobile() {
        setInnerWidth(window?.innerWidth);
        setIsMobile(window?.innerWidth < 899);
    }

    useEffect(() => {
        if (typeof window != undefined) {
            setInnerWidth(window?.innerWidth);
            setIsMobile(window?.innerWidth < 899);
            document.addEventListener("resize", updateIsMobile, {
                passive: true,
            });
        }

        return () => document.removeEventListener("resize", updateIsMobile);
    }, []);

    return (
        <InnerWidthContext.Provider value={{ isMobile, innerWidth }}>
            {props.children}
        </InnerWidthContext.Provider>
    );
};
